import axios from 'axios';
import { defineStore } from 'pinia';

export const useMonitoringStore = defineStore('monitoring', {
    state: () => ({}),

    actions: {
        async fetchStatus() {
            const { data } = await axios.get('monitoring/status');
            return data;
        },

        async fetchIncidents(params) {
            const { data } = await axios.get('monitoring/incidents', { params });
            return data;
        },

        async fetchIncident(id) {
            const { data } = await axios.get(`monitoring/incident/${id}`, {
                params: { includes: 'occurrences' }
            });
            return data;
        },

        async closeIncident(id) {
            const { data } = await axios.post(`monitoring/incident/${id}/close`);
            return data;
        }
    }
});
